import * as React from 'react'
import { InputAdornment, Slider, TextField } from '@mui/material';
import FormatedNumber from '../general/FormatedNumber';
import LiquidityAdSlider from './LiquidityAdSlider';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import FormatSatoshi from '../general/FormatSatoshi';
import SatoshiToUsd from '../general/SatoshiToUsd';
import NodeCapacityFilter from './filters/NodeCapacityFilter';
import { BaseFilterState } from '../graph/whole-graph/filters/helpers/FilterStates';
import SatoshiSvg from '../general/SatoshiSvg';

function roundSatoshi(sat: number) {
  let roundVal = 10 * 1000 * 1000;
  if (sat < 1000 * 1000) {
    roundVal = 100 * 1000;
  } else if (sat < 10 * 1000 * 1000) {
    roundVal = 1000 * 1000;
  }
  return Math.round(sat / roundVal) * roundVal;
}

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props: any, ref) {
  const { onChange, ...other } = props;

  return (
    <div className='flex'>
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        isNumericString
        suffix='sat'
      />
    </div>
  );
});

NumberFormatCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
};


type Props = {
  onChange: (newSatoshi: number) => any
}

const LiquidityAdSatoshiInput: React.FC<Props> = ({ onChange }: Props) => {
  const [satoshi, setSatoshi] = React.useState<number>(1000 * 1000);

  React.useEffect(() => {
    onChange(satoshi);
  }, [satoshi])


  return (
    <div>

      <div className='flex flex-col justify-center items-center'>
        <div>
          <div>
            <p className='text-gray-600'>Demanded Liquidity</p>
            <TextField
              label={""}
              placeholder="Demanded satoshi"
              variant='outlined'
              // size={"normal"}
              // autoFocus={true}
              value={satoshi}
              inputProps={{
                // min: 0, 
                style: { textAlign: 'right', fontWeight: 700, fontSize: '1.3rem' }
              }}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">
                    <SatoshiSvg />
                  </InputAdornment>
                ),
              }}
              onChange={e => {
                const parsed = Number.parseInt(e.target.value);
                if (!isNaN(parsed)) {
                  const maxValue = 10 * 100 * 1000 * 1000;
                  if (parsed > maxValue) {
                    setSatoshi(maxValue)
                  } else {
                    setSatoshi(parsed);
                  }

                }
              }}
              className="bg-white no-border rounded focus:outline-none font-medium text-xl"
            />
          </div>
          <div className='pt-4'>
            <div style={{ maxWidth: '400px' }}>
              <LiquidityAdSlider satoshi={satoshi} onChange={newSat => {
                const roundedSats = roundSatoshi(newSat);
                setSatoshi(roundedSats)
              }}
              />
            </div>
          </div>

        </div>

      </div>

    </div>

  );
}

export default LiquidityAdSatoshiInput;

